export const ContentListStyles = {
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingY: 2,
  },
  gradientText: (theme: any) => ({
    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "bold",
  }),
  contentContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 2.5,
  },
  cardWrapper: {
    flexBasis: {
      xs: "100%",
      sm: "calc(50% - 24px)",
      md: "calc(33.333% - 24px)",
      lg: "calc(25% - 24px)",
      xl: "calc(25% - 24px)",
    },
    minWidth: 300,
    maxWidth: 350,
  },
  card: {
    height: "420px",
    display: "flex",
    flexDirection: "column",
  },
  imageContainer: {
    position: "relative",
    height: "200px",
    backgroundColor: "lightgrey",
  },
  noImageBox: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  statusChip: {
    position: "absolute",
    top: 8,
    right: 8,
  },
  tagsContainer: {
    px: 1,
    py: 1,
  },
  tag: {
    mr: 0.5,
  },
  cardContent: {
    paddingY: 0,
    flex: 1,
  },
  contentText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    fontSize: "0.9rem",
  },
  cardActions: {
    justifyContent: "flex-start",
    paddingX: 2,
    mt: "auto",
  },
  previewButton: {
    borderRadius: "4px",
  },
  alertBox: (bannerColor: string, theme: any) => ({
    width: "100%",
    backgroundColor: bannerColor || theme.palette.error.light,
    minHeight: "60px",
  }),
  alertContent: {
    display: "flex",
    padding: "10px",
    gap: "10px",
    alignItems: "center",
  },
  alertText: {
    fontSize: "0.9rem",
    color: "#ffffff",
  },
  alertLink: {
    color: "#000000",
  },
};
